import axiosInstance from 'services/axiosMiddleware';

export async function studentSupport(studentsdata) {
  try {
    const response = await axiosInstance.post('support/studentQuery', studentsdata);

    if (response.data.status) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error sending student support query:', error);
    throw new Error(error?.response?.data?.message || 'Failed to send support query');
  }
}
